module.exports = __webpack_public_path__ + "img/shelf.03c2b988.svg";